/**
 * EmptyState — reusable empty-slice affordance for the traffic
 * dashboard. Renders honest copy so an operator immediately knows
 * whether the empty state means "no data yet" (fresh install) or
 * "no data for the requested slice" (real gap).
 *
 * Copy contract per Commit C dispatch §4:
 *   * If firstRollupDate is provided → "No data yet — analytics
 *     began <firstRollupDate>"
 *   * If firstRollupDate is null/undefined → "No data yet — analytics
 *     beginning today"
 *
 * Fixed height so the surrounding grid layout doesn't reflow between
 * empty and populated states.
 */
import React from "react";

export default function EmptyState({
  firstRollupDate,
  variant = "card",
  testId,
}) {
  const copy = firstRollupDate
    ? `No data yet — analytics began ${firstRollupDate}`
    : "No data yet — analytics beginning today";

  return (
    <div
      className="flex items-center justify-center text-center text-sm"
      style={{
        color: "var(--pp-text-soft)",
        minHeight: variant === "chart" ? "280px" : "80px",
      }}
      data-testid={testId || "analytics-empty-state"}
    >
      <span>{copy}</span>
    </div>
  );
}
